import { combineEpics } from "redux-observable";
import { messageDismissEpicReducer } from "../ducks/messageDismiss.duck.js";
const dismissMessgeEpic = combineEpics(messageDismissEpicReducer.epic);
export {
  dismissMessgeEpic
};
//# sourceMappingURL=messageDismiss.epics.js.map
